import { http } from 'services/http';
import { WAREHOUSE_TASK_GET_ONE, WAREHOUSE_TASK_ITEMS_GET_MANY } from 'api/query-keys.ts';
import type { TSetWhTaskItemPickUpDateReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useSetWhTaskItemPickUpDate = (whTaskId: number) => {
  return useMutationBase<void, unknown, TSetWhTaskItemPickUpDateReq>({
    mutationFn: async (variables) => {
      const res = await http.post(`/v1/warehouse-tasks/${whTaskId}/warehouse-task-items/pick-up`, variables);

      return res.data;
    },

    invalidateCallback: () => [
      [WAREHOUSE_TASK_GET_ONE, whTaskId],
      [WAREHOUSE_TASK_ITEMS_GET_MANY, whTaskId],
    ],
  });
};
